import { Stack, Typography, useTheme } from "@mui/material";
import { desiredFeaturesList } from "../data";
import { CheckboxItem } from "./CheckboxItem";
import { useContext } from "react";
import { FeedbackContext } from "../context";
import { OtherCustomInput } from "./OtherCustomInput";

export const SelectMissingFeatures = () => {
  const theme = useTheme();
  const context = useContext(FeedbackContext);
  if (!context) throw new Error("wrong context provided");
  const { missingFeatures, toggleFeature, toggleOtherFeature } = context;

  const isOtherSelected = missingFeatures.some((item) =>
    item.value.startsWith("other_"),
  );

  return (
    <Stack gap="16px">
      <Typography variant="body-medium" color={theme.palette.lightBg.low}>
        Would you mention the features missing that once made live would make
        you reconsider us?
      </Typography>
      <Stack gap="12px">
        {desiredFeaturesList.map((feature) => {
          const isChecked = missingFeatures.some(
            (item) => item.value === feature.value,
          );
          return (
            <CheckboxItem
              key={feature.value}
              label={feature.label}
              isChecked={isChecked}
              onClick={() =>
                toggleFeature({
                  label: feature.label,
                  value: feature.value,
                })
              }
            />
          );
        })}
        <OtherCustomInput
          isSelected={isOtherSelected}
          onClick={toggleOtherFeature}
          placeholder="Tell us which features you need"
        />
      </Stack>
    </Stack>
  );
};
